/* React Query rond de datalaag van Mail en AI. De client is de gewone CRM-client (sessie van de
 * ingelogde gebruiker); RLS geeft alleen de super_admin rijen. */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { haalMailAi, type MailAiClient } from './data/mailAi';

/* De gegenereerde types kennen de tabellen van na types.ts niet. */
const client = supabase as unknown as MailAiClient;

/** NATS levert elke 10 minuten aan; elke minuut opnieuw lezen houdt "x min geleden" eerlijk.
 *  Eén herkansing: een leesfout hoort binnen een paar tellen op de pagina te staan. */
export const useMailAi = (aan: boolean) =>
  useQuery({ queryKey: ['mail-ai'], queryFn: () => haalMailAi(client), enabled: aan, staleTime: 30_000, refetchInterval: 60_000, retry: 1 });
